@if (!tabsDisplayReady) {
<div class="tabs-resolving-wrapper">
  <mat-progress-spinner
    diameter="32"
    mode="indeterminate"
  ></mat-progress-spinner>
  <p>Indlæser faner...</p>
</div>
}

<ng-container *ngrxLet="templateService.currentMode$ as currentMode">
  @if (tabsDisplayReady) {
  <div class="dynamic-tabs-shell">
    @if (currentMode !== 1) {
    <div class="duna-custom-tab-header">
      <button
        type="button"
        class="duna-tab-scroll-btn"
        [class.duna-tab-scroll-btn--hidden]="!canScrollTabsLeft"
        (click)="scrollTabs(-1)"
        aria-label="Forrige faner"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <div
        class="duna-tab-label-scroll"
        #tabLabelScroll
        (scroll)="updateTabScrollState()"
      >
        @for (tab of tabs$ | async; track trackBySlug(i, tab); let i = $index) {
        <button
          type="button"
          class="duna-tab-button"
          [class.duna-tab-button--active]="i === selectedIndex"
          (click)="selectTabDirectly(i)"
        >
          {{ tab.text }}
        </button>
        }
      </div>
      <button
        type="button"
        class="duna-tab-scroll-btn"
        [class.duna-tab-scroll-btn--hidden]="!canScrollTabsRight"
        (click)="scrollTabs(1)"
        aria-label="Næste faner"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
    }
    <mat-tab-group
      class="dynamic-tabs-tab-group"
      [class.dynamic-tabs-tab-group--header-hidden]="currentMode !== 1"
      [selectedIndex]="selectedIndex"
      (selectedIndexChange)="selectTabDirectly($event)"
      animationDuration="0ms"
    >
      @for (tab of tabs$ | async; track trackBySlug(i, tab); let i = $index) {
      <mat-tab [label]="tab.text">
        @if (tab.slug === activeTab) {
        <div class="tab-content-wrapper">
          @if (tabService.getTabState$(tab.slug) | async; as tabState) { @if
          (tabState.loading || !tabState.loaded) {
          <div class="tab-loading-wrapper">
            <mat-progress-spinner
              diameter="32"
              mode="indeterminate"
            ></mat-progress-spinner>
            <p>Indlæser indhold...</p>
          </div>
          } @if (tabState.loaded && !tabState.loading) {
          <ng-container
            *ngComponentOutlet="
              DynamicTabsContentComponent;
              injector: getTabInjector(tab.slug)
            "
          ></ng-container>
          } }
        </div>
        }
      </mat-tab>
      }
    </mat-tab-group>
  </div>
  }
</ng-container>
